import { FORM_FIELDS } from '../consts';
import clearIcon from '../../../../assets/svg/xStrokeIcon.svg';
import { ValidateFieldTypes, validationSchemeMap } from '../../../../helpers/inputUtils.helper';

export const wireOutForm = () => [
  {
    type: 'single',
    inputType: 'text',
    name: 'MANAGE_VENDOR.FORM.BUSINESS_NAME',
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.BUSINESS_NAME_REQUIRED',
    validateScheme: /^.{3,40}$/,
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.BUSINESS_NAME_VALIDATION',
    inputId: FORM_FIELDS.BUSINESS_NAME,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    name: 'MANAGE_VENDOR.FORM.EMAIL_OPTIONAL',
    requiredMessage: '',
    validateScheme: validationSchemeMap[ValidateFieldTypes.EMAIL],
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.EMAIL_VALIDATION',
    inputId: FORM_FIELDS.EMAIL,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 17,
    name: 'MANAGE_VENDOR.FORM.WIRE_ACCOUNT',
    replaceValueScheme: /\D/g,
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.WIRE_ACCOUNT_REQUIRED',
    validateScheme: /^[0-9]{5,17}$/,
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.WIRE_ACCOUNT_VALIDATION',
    inputId: FORM_FIELDS.WIRE_ACCOUNT_NUMBER,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 9,
    name: 'MANAGE_VENDOR.FORM.WIRE_ROUTE',
    replaceValueScheme: /\D/g,
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.WIRE_ROUTE_REQUIRED',
    validateScheme: /^[0-9]{9}$/,
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.WIRE_ROUTE_VALIDATION',
    inputId: FORM_FIELDS.WIRE_ROUTING_NUMBER,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    name: 'MANAGE_VENDOR.FORM.LINE_1',
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.LINE_1_REQUIRED',
    validateScheme: /^[A-Za-z0-9-\s]+$/,
    validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ADDRESS.VALIDATE',
    inputId: FORM_FIELDS.LINE_ONE,
    shouldValidateOnClick: true,
    clearIcon: {
      Asset: clearIcon,
      styles: 'stroke-bw01 w-[50%] h-[50%] mx-auto my-auto',
    },
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        maxLen: 20,
        name: 'MANAGE_VENDOR.FORM.LINE_2',
        requiredMessage: '',
        validateScheme: '',
        validateErrorMessage: '',
        inputId: FORM_FIELDS.LINE_TWO,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'text',
        name: 'MANAGE_VENDOR.FORM.ZIP',
        replaceValueScheme: /\D/g,
        maxLen: 5,
        requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.ZIP_CODE_REQUIRED',
        validateScheme: /^[0-9]{5}$/,
        validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ZIP.VALIDATE',
        inputId: FORM_FIELDS.ZIP_CODE,
        shouldValidateOnClick: true,
      },
    ],
  },
  {
    inputType: 'select',
    type: 'single',
    name: 'MANAGE_VENDOR.FORM.STATE',
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.STATE_REQUIRED',
    defaultOption: 'MANAGE_VENDOR.FORM.STATE',
    inputId: FORM_FIELDS.STATE,
  },
  {
    inputType: 'text',
    type: 'single',
    name: 'MANAGE_VENDOR.FORM.CITY',
    requiredMessage: 'MANAGE_VENDOR.FORM_VALIDATION.CITY_REQUIRED',
    validateScheme: /^[A-Za-z\s]+$/,
    validateErrorMessage: 'SUPPLIER.MANAGE.FORM.CITY.VALIDATE',
    inputId: FORM_FIELDS.CITY,
    shouldValidateOnClick: true,
  },
  {
    type: 'trigger',
    triggerTitle: 'MANAGE_VENDOR.FORM.ACH_TRANSFER_GROUP',
    triggerId: 'ACH_GROUP',
    shouldHideTrigger: false,
  },
  {
    type: 'single',
    inputType: 'text',
    linkedTriggerId: 'ACH_GROUP',
    maxLen: 17,
    name: 'MANAGE_VENDOR.FORM.ACH_ACCOUNT',
    replaceValueScheme: /\D/g,
    requiredMessage: '',
    validateScheme: /^[0-9]{5,17}$/,
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.ACH_ACCOUNT_VALIDATION',
    inputId: FORM_FIELDS.ACH_ACCOUNT_NUMBER,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    linkedTriggerId: 'ACH_GROUP',
    maxLen: 9,
    name: 'MANAGE_VENDOR.FORM.ACH_ROUTE',
    replaceValueScheme: /\D/g,
    requiredMessage: '',
    validateScheme: /^[0-9]{9}$/,
    validateErrorMessage: 'MANAGE_VENDOR.FORM_VALIDATION.ACH_ROUTING_VALIDATION',
    inputId: FORM_FIELDS.ACH_ROUTING_NUMBER,
    shouldValidateOnClick: true,
  },
];
